import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'

export default (state, props) => isAdminSelector(state, props)
